import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const GYNECOLOGICAL_NECK_FORM_INITIAL_VALUES = {
  sections: {
    gynecologicalNeck: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamGynecologicalNeckSections =
  keyof typeof GYNECOLOGICAL_NECK_FORM_INITIAL_VALUES.sections;
